var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.474,
    height: 28.471,
    viewBox: "0 0 28.474 28.471",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1,
    y1: 0.069,
    x2: 0.079,
    y2: 0.945,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4adede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6172d6"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Group_1258",
    "data-name": "Group 1258",
    d: "M1029.05,546.8c.007-.011-.056-.031-.119-.044a5.41,5.41,0,0,1-4.64-4.172c-.038-.155-.068-.31-.1-.465l-.036-.186,0-16.569a.387.387,0,0,0,.05-.152,5.412,5.412,0,0,1,4.9-4.632c.16-.01.323-.014.488-.014s1.206.014,1.206.014l0-.484c0-.186.005-.354,0-.521a1.074,1.074,0,0,1,.775-1.244l.4.006a1.1,1.1,0,0,1,.729,1.253,4.089,4.089,0,0,0-.008.52l0,.426h11.391l0-.428c0-.169.007-.335,0-.5a1.1,1.1,0,0,1,.764-1.281l.4.007a1.073,1.073,0,0,1,.732,1.219,4.757,4.757,0,0,0-.008.551l0,.443h1.24a5.408,5.408,0,0,1,5.212,3.992c.056.2.1.4.139.608l.052.252,0,16.567h0c-.011,0-.03.06-.044.119a5.4,5.4,0,0,1-4.119,4.563c-.174.041-.348.075-.521.11l-.219.043Zm-2.995-5.479a3.493,3.493,0,0,0,3.4,3.577l8.943,0,8.768,0a3.527,3.527,0,0,0,3.565-3.4V529.1h-24.671Zm3.825-18.884a3.791,3.791,0,0,0-2.927,1.169,4.261,4.261,0,0,0-.875,3.4l.017.157h24.595l.017-.157a4.292,4.292,0,0,0-.884-3.415,3.763,3.763,0,0,0-2.856-1.163,5.076,5.076,0,0,0-.834.071l-.148.025,0,.86c0,.474,0,.949,0,1.426a.946.946,0,1,1-1.892.011c-.007-.483,0-.962,0-1.445l0-.913h-11.4l0,1.118c0,.412,0,.825,0,1.237a.946.946,0,1,1-1.893-.007c0-.221,0-.439,0-.655l0-1.652-.154-.02A5.943,5.943,0,0,0,1029.88,522.442Zm10.43,11.916a.6.6,0,0,1-.511-.66v-.692a.607.607,0,0,1,.5-.673h7.893a.608.608,0,0,1,.512.671v.681a.608.608,0,0,1-.5.673h-7.894Zm-11.484,0a.6.6,0,0,1-.511-.66v-.692a.607.607,0,0,1,.5-.673h7.893a.609.609,0,0,1,.512.671v.681a.608.608,0,0,1-.5.673h-7.894Zm11.484,6.531a.6.6,0,0,1-.511-.66v-.692a.607.607,0,0,1,.5-.673h7.893a.609.609,0,0,1,.512.672v.68a.608.608,0,0,1-.5.673h-7.894Zm-11.484,0a.6.6,0,0,1-.511-.66v-.692a.607.607,0,0,1,.5-.673h7.893a.61.61,0,0,1,.512.672v.68a.608.608,0,0,1-.5.673h-7.894Z",
    transform: "translate(-1024.155 -518.333)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderSetting);
export default __webpack_public_path__ + "static/media/CalenderSetting.93f8d7cd45b051331864fcfa28b07fe4.svg";
export { ForwardRef as ReactComponent };